import { render, staticRenderFns } from "./WindowList.vue?vue&type=template&id=9010fc5a&scoped=true"
import script from "./WindowList.vue?vue&type=script&lang=js"
export * from "./WindowList.vue?vue&type=script&lang=js"
import style0 from "./WindowList.vue?vue&type=style&index=0&id=9010fc5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9010fc5a",
  null
  
)

export default component.exports